import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import { genElObject } from "@components/utils/EditorDialogElementGenerator";
import DepartmentSelectorDialog from "../../../../dialogs/selectors/DepartmentSelectorDialog";

const AlatBeratFilter = (props) => {
  const { filterValue, setFilterValue, onClickRefresh } = props;

  const [showDepartmentSelector, setShowDepartmentSelector] = useState(false);

  // handle ui event section

  const handleOnKeyDown = (e) => {
    if (e.key === "Enter") {
      if (onClickRefresh) onClickRefresh();
    }
  };

  const handleOnConfirmDepartment = (event, datas) => {
    if (datas && datas.length > 0) {
      const department = datas[0];
      setFilterValue((prevData) => ({
        ...prevData,
        data_department: department,
        department_id: department.id,
      }));
      setShowDepartmentSelector(false);
    }
  };

  // custom ui section

  const elDepartment = genElObject({
    field: "department_id",
    name: "Department",
    value: filterValue.data_department ? filterValue.data_department.nama : "",
    onClick: () => setShowDepartmentSelector(true),
    onClear: () =>
      setFilterValue((prevData) => ({
        ...prevData,
        data_department: null,
        department_id: null,
      })),
  });

  return (
    <div className="row-between-end gap-4 w-full">
      <DepartmentSelectorDialog
        title={"Pilih Department"}
        visible={showDepartmentSelector}
        onHide={() => setShowDepartmentSelector(false)}
        onConfirm={handleOnConfirmDepartment}
      />

      {/* filter component section */}
      <div className="row-start-end gap-4 w-full flex-wrap">
        <div className="col-start-start gap-1">
          <div className="row-start-center gap-2">
            <i className="pi pi-search text-slate-500 text-xs" />
            <span className="text-sm font-semibold text-slate-500">Kode Unit</span>
          </div>
          <InputText
            value={filterValue.kode_unit}
            onChange={(e) =>
              setFilterValue({ ...filterValue, kode_unit: e.target.value })
            }
            onKeyDown={handleOnKeyDown}
            className="w-full md:w-14rem"
          />
        </div>
        <div className="col-start-start gap-1">
          <div className="row-start-center gap-2">
            <i className="pi pi-search text-slate-500 text-xs" />
            <span className="text-sm font-semibold text-slate-500">Nama</span>
          </div>
          <InputText
            value={filterValue.nama}
            onChange={(e) =>
              setFilterValue({ ...filterValue, nama: e.target.value })
            }
            onKeyDown={handleOnKeyDown}
            className="w-full md:w-14rem"
          />
        </div>
        <div className="col-start-start w-full sm:w-[14rem]">
          {elDepartment}
        </div>
      </div>
      {/* refresh section */}
      <Button
        icon="pi pi-refresh"
        outlined
        rounded
        onClick={() => {
          if (onClickRefresh) onClickRefresh();
        }}
      />
    </div>
  );
};

export default AlatBeratFilter;
